import React from "react";
import "../../../assets/css/footer/cgv-cgu.css";

export default function CgvCgu() {
  return (
    <main className="cgv-page">
      <article className="cgv-document">
        <h1>CONDITIONS GÉNÉRALES DE VENTE ET D’UTILISATION</h1>
        <h2>DEAL.MG</h2>

        <p className="cgv-date">Dernière mise à jour : le 09 juin 2026</p>

        <p>
          Les présentes Conditions Générales de Vente et d’Utilisation,
          ci-après les “CGV / CGU”, ont pour objet de définir les conditions
          dans lesquelles les utilisateurs accèdent à la plateforme Deal.mg et
          utilisent ses services.
        </p>

        <p>
          L’utilisation de Deal.mg implique l’acceptation pleine et entière des
          présentes CGV / CGU.
        </p>

        <p>
          Deal.mg est une plateforme de petites annonces permettant la mise en
          relation entre vendeurs et acheteurs. Deal.mg agit uniquement comme
          intermédiaire technique de publication et de mise en relation.
          Deal.mg n’intervient pas dans les transactions conclues entre les
          utilisateurs.
        </p>

        <p>
          Chaque utilisateur reconnaît utiliser Deal.mg sous sa seule
          responsabilité.
        </p>

        <h3>I. CONDITIONS GÉNÉRALES DE VENTE, CGV</h3>

        <section>
          <h4>1. Identification de la plateforme</h4>

          <p>
            Deal.mg est une plateforme numérique de petites annonces exploitée
            par la société DEAL-MG SARL.
          </p>

          <table className="cgv-table">
            <thead>
              <tr>
                <th>Information</th>
                <th>Détail</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dénomination sociale</td>
                <td>DEAL-MG SARL</td>
              </tr>
              <tr>
                <td>Forme juridique</td>
                <td>Société à Responsabilité Limitée, SARL</td>
              </tr>
              <tr>
                <td>Capital social</td>
                <td>1 000 000 Ariary</td>
              </tr>
              <tr>
                <td>Siège social</td>
                <td>
                  29 rue Ratsimilaho, Faravohitra Mandrosoa, CUA Antananarivo I,
                  Antananarivo Renivohitra, Madagascar
                </td>
              </tr>
              <tr>
                <td>RCS</td>
                <td>RCS Antananarivo 2026 B 00236</td>
              </tr>
              <tr>
                <td>NIF</td>
                <td>6019573963</td>
              </tr>
              <tr>
                <td>STAT</td>
                <td>62011 11 2026 0 10233</td>
              </tr>
              <tr>
                <td>Régime fiscal</td>
                <td>Impôt sur les Sociétés, IS</td>
              </tr>
              <tr>
                <td>Date d’immatriculation</td>
                <td>18 février 2026</td>
              </tr>
              <tr>
                <td>Gérant</td>
                <td>Monsieur Ammar Abdealy</td>
              </tr>
              <tr>
                <td>Activité déclarée</td>
                <td>
                  services numériques, publicité, développement web,
                  e-commerce, petites annonces sur internet
                </td>
              </tr>
              <tr>
                <td>Téléphone</td>
                <td>+261 34 35 36 345</td>
              </tr>
              <tr>
                <td>Site internet</td>
                <td>www.deal.mg</td>
              </tr>
              <tr>
                <td>Email de contact</td>
                <td>contact@deal.mg</td>
              </tr>
              <tr>
                <td>Email de signalement</td>
                <td>contact@deal.mg</td>
              </tr>
            </tbody>
          </table>

          <p>
            Deal.mg agit uniquement comme plateforme de mise en relation entre
            vendeurs et acheteurs.
          </p>

          <p>
            Deal.mg n’est ni vendeur, ni acheteur, ni mandataire, ni courtier,
            ni intermédiaire financier, ni transporteur, ni dépositaire, ni
            garant des transactions conclues entre utilisateurs.
          </p>

          <p>
            Deal.mg ne devient jamais partie à la vente conclue entre un vendeur
            et un acheteur.
          </p>
        </section>

        <section>
          <h4>2. Objet des CGV</h4>
          <p>
            Les présentes CGV régissent les services numériques proposés par
            Deal.mg, notamment la publication d’annonces, les options de mise en
            avant, les boosts de visibilité, les services promotionnels et tout
            autre service proposé sur la plateforme.
          </p>
          <p>
            Ces services concernent uniquement la publication, la visibilité ou
            la mise en avant des annonces sur Deal.mg.
          </p>
          <p>
            Ils ne garantissent pas la vente du bien, le nombre de vues, le
            nombre de contacts, la qualité des acheteurs potentiels, la
            solvabilité des acheteurs, ni la conclusion d’une transaction.
          </p>
        </section>

        <section>
          <h4>3. Gratuité de lancement et services payants</h4>
          <p>
            Dans le cadre de son lancement, Deal.mg propose une période de
            gratuité jusqu’au 1er septembre 2026.
          </p>
          <p>
            Pendant cette période, certains services de publication peuvent être
            proposés gratuitement, selon les conditions affichées sur la
            plateforme.
          </p>
          <p>
            À partir du 1er septembre 2026, la publication d’annonces et
            certaines options de visibilité pourront devenir payantes.
          </p>
          <p>
            Les prix seront déterminés notamment selon la catégorie de
            l’annonce, le type de bien ou de service proposé, le niveau de
            visibilité choisi, les options sélectionnées par l’utilisateur, la
            durée de publication ou de mise en avant, et les éventuelles offres
            promotionnelles en cours.
          </p>
          <p>
            Les tarifs applicables seront affichés sur la plateforme avant toute
            validation de commande ou activation d’un service payant.
          </p>
          <p>
            Deal.mg se réserve le droit de modifier ses tarifs à tout moment.
            Les modifications de tarifs ne s’appliquent pas aux commandes déjà
            validées.
          </p>
        </section>

        <section>
          <h4>4. Boost et mise en avant des annonces</h4>
          <p>
            Deal.mg pourra proposer des options de boost ou de mise en avant
            afin d’améliorer la visibilité d’une annonce.
          </p>
          <p>
            Ces options pourront notamment être proposées lors de la publication
            initiale de l’annonce, après une certaine durée de publication,
            après un mois si l’article n’a pas été vendu, dans le cadre d’une
            relance d’annonce invendue, ou dans le cadre d’une offre
            promotionnelle.
          </p>
          <p>
            Le boost ou la mise en avant augmente la visibilité de l’annonce
            selon les modalités affichées sur la plateforme, mais ne garantit
            pas la vente du bien, le nombre de contacts, ni la qualité des
            contacts reçus.
          </p>
          <p>
            Les conditions, durées et prix des boosts seront indiqués à
            l’utilisateur avant validation.
          </p>
        </section>

        <section>
          <h4>5. Commande et activation du service</h4>
          <p>
            Le service est considéré comme commandé lorsque l’utilisateur valide
            la publication de son annonce ou l’activation d’une option proposée
            par Deal.mg.
          </p>
          <p>
            Le service est considéré comme activé dès lors que l’annonce est
            publiée, mise en avant, boostée ou rendue visible sur la plateforme.
          </p>
          <p>
            Deal.mg se réserve le droit de refuser, suspendre ou supprimer une
            annonce qui ne respecte pas les présentes conditions, même après
            validation ou paiement.
          </p>
        </section>

        <section>
          <h4>6. Paiement</h4>
          <p>
            Lorsque des services payants sont proposés, les paiements peuvent
            être effectués par les moyens proposés sur la plateforme, notamment
            MVola, Orange Money, Airtel Money, carte bancaire, ou tout autre
            moyen de paiement éventuellement proposé par Deal.mg.
          </p>
          <p>
            L’utilisateur garantit qu’il est autorisé à utiliser le moyen de
            paiement choisi.
          </p>
          <p>
            En cas d’échec, d’annulation, de fraude, d’opposition, de
            contestation du paiement ou d’utilisation frauduleuse d’un moyen de
            paiement, Deal.mg peut suspendre ou supprimer le service concerné,
            sans remboursement.
          </p>
        </section>

        <section>
          <h4>7. Absence de remboursement</h4>
          <p>Aucun remboursement ne sera effectué après activation du service.</p>
          <p>
            L’utilisateur reconnaît que les services proposés par Deal.mg sont
            des services numériques de publication, de visibilité ou de mise en
            avant, exécutés dès leur activation.
          </p>
          <p>
            Aucun remboursement ne pourra être demandé en cas d’absence de
            vente, d’absence de contact, de faible visibilité, de retrait de
            l’annonce pour non-respect des règles, d’erreur imputable à
            l’utilisateur dans le contenu de l’annonce, de suppression d’un
            compte pour fraude ou comportement interdit, de litige entre vendeur
            et acheteur, de produit défectueux, de produit non conforme ou de
            produit invendu.
          </p>
          <p>
            Deal.mg peut toutefois, à titre commercial et sans obligation,
            proposer un avoir, une republication ou une compensation.
          </p>
        </section>

        <section>
          <h4>8. Absence de garantie commerciale</h4>
          <p>
            Deal.mg ne garantit pas la vente du bien ou du service proposé, le
            nombre de vues de l’annonce, le nombre de contacts reçus, la qualité
            des acheteurs potentiels, la solvabilité des acheteurs, la réalité
            ou la fiabilité d’une transaction, la bonne foi des utilisateurs,
            l’absence de fraude ou de tentative d’arnaque, ni la conformité
            réelle des produits proposés par les annonceurs.
          </p>
          <p>
            Le paiement effectué par l’utilisateur concerne uniquement la
            publication, la visibilité ou la mise en avant de l’annonce.
          </p>
        </section>

        <section>
          <h4>9. Limitation de responsabilité de Deal.mg</h4>
          <p>
            Deal.mg agit uniquement comme intermédiaire technique de publication
            et de mise en relation.
          </p>
          <p>
            Deal.mg ne contrôle pas physiquement les produits, ne vérifie pas
            systématiquement l’identité réelle des utilisateurs, ne garantit pas
            l’exactitude des annonces et ne garantit pas la bonne exécution des
            transactions entre acheteurs et vendeurs.
          </p>
          <p>
            La responsabilité de Deal.mg, si elle devait être engagée, est
            strictement limitée au montant effectivement payé par l’utilisateur
            pour le service concerné.
          </p>
          <p>
            Deal.mg ne pourra être tenue responsable des dommages directs ou
            indirects liés aux transactions entre utilisateurs, notamment perte
            financière, perte de chance, arnaque, escroquerie, tentative
            d’escroquerie, non-paiement, non-livraison, produit défectueux,
            produit non conforme, produit contrefait, produit volé, fausse
            identité, mauvaise rencontre, accident, agression, vol, menace ou
            litige entre vendeur et acheteur.
          </p>
          <p>
            Chaque utilisateur reconnaît que les transactions sont conclues
            directement entre acheteur et vendeur, sous leur seule
            responsabilité.
          </p>
        </section>

        <h3>II. CONDITIONS GÉNÉRALES D’UTILISATION, CGU</h3>

        <section>
          <h4>10. Rôle de Deal.mg</h4>
          <p>
            Deal.mg est une plateforme de petites annonces permettant la mise en
            relation entre vendeurs et acheteurs.
          </p>
          <p>
            Deal.mg n’intervient pas dans la négociation, le paiement entre
            acheteur et vendeur, la livraison, la remise du bien, la
            vérification du produit, le test du produit, la garantie du produit,
            le service après-vente, le remboursement entre utilisateurs ou
            l’exécution de la transaction.
          </p>
          <p>
            La transaction est conclue directement et exclusivement entre le
            vendeur et l’acheteur.
          </p>
          <p>
            Deal.mg ne peut pas être tenue responsable de ce qui peut arriver
            entre acheteur et vendeur avant, pendant ou après la transaction.
          </p>
        </section>

        <section>
          <h4>11. Acceptation des CGU</h4>
          <p>Tout accès ou usage de Deal.mg implique l’acceptation des présentes CGU.</p>
          <p>
            L’utilisateur s’engage à utiliser la plateforme de manière loyale,
            honnête, prudente et conforme aux lois en vigueur à Madagascar.
          </p>
          <p>
            Si l’utilisateur refuse les présentes conditions, il doit cesser
            immédiatement d’utiliser la plateforme.
          </p>
        </section>

        <section>
          <h4>12. Création de compte</h4>
          <p>
            L’accès à certaines fonctionnalités peut nécessiter la création d’un
            compte utilisateur.
          </p>
          <p>
            L’utilisateur s’engage à fournir des informations exactes, complètes
            et à jour.
          </p>
          <p>
            L’utilisateur est seul responsable de la confidentialité de ses
            identifiants et de toute activité réalisée depuis son compte.
          </p>
          <p>
            Deal.mg peut suspendre ou supprimer un compte en cas de suspicion de
            fraude, d’usurpation d’identité, de comportement abusif, de
            comportement contraire à l’éthique de la plateforme ou de violation
            des présentes conditions.
          </p>
        </section>

        <section>
          <h4>13. Responsabilité générale de l’utilisateur</h4>
          <p>
            Chaque utilisateur est seul responsable des informations qu’il
            publie, des photos, descriptions et prix indiqués, de la légalité
            des biens ou services proposés, de l’authenticité des produits, de
            la disponibilité réelle du bien, de la livraison ou remise du bien,
            du paiement ou de l’encaissement, du service après-vente, des
            garanties éventuellement proposées et de ses obligations fiscales,
            administratives et légales.
          </p>
          <p>
            L’utilisateur s’engage à ne publier aucune annonce fausse,
            trompeuse, frauduleuse, abusive, illégale ou portant atteinte aux
            droits d’un tiers.
          </p>
        </section>

        <section>
          <h4>14. Obligation de sincérité de l’annonceur</h4>
          <p>
            L’annonceur a une obligation stricte de sincérité, d’exactitude et
            de transparence.
          </p>
          <p>
            L’annonceur s’interdit formellement de mentir, dissimuler une
            information importante, masquer un défaut, exagérer l’état du
            produit, publier de fausses photos ou présenter un produit d’une
            manière trompeuse.
          </p>
          <p>
            L’annonceur garantit que toutes les informations publiées sont
            exactes, sincères, complètes et conformes à la réalité, notamment
            les photos, la description, la marque, le modèle, l’année, les
            dimensions, l’état du produit, le prix, la disponibilité, les
            défauts éventuels, les accessoires inclus, l’origine du produit et
            les conditions de remise ou de livraison.
          </p>
          <p>
            L’annonceur doit mentionner clairement tout défaut connu, toute
            panne, toute usure importante, toute réparation nécessaire ou toute
            information susceptible d’influencer la décision de l’acheteur.
          </p>
          <p>
            L’annonceur reconnaît que toute information fausse, incomplète,
            trompeuse ou volontairement omise engage sa seule responsabilité.
          </p>
        </section>

        <section>
          <h4>15. Photos et informations non conformes</h4>
          <p>Les photos publiées doivent correspondre au produit réellement proposé.</p>
          <p>
            Toute photo illustrative, non contractuelle, retouchée ou provenant
            d’une source externe doit être clairement indiquée comme telle.
          </p>
          <p>
            Il est interdit de publier des photos ne correspondant pas au
            produit réel, des photos d’un produit similaire mais différent, des
            photos masquant volontairement un défaut, des photos retouchées de
            manière trompeuse, des informations fausses ou approximatives, une
            description volontairement incomplète, un prix mensonger ou
            trompeur, un état du produit différent de la réalité, une annonce
            destinée à attirer l’utilisateur vers un autre produit ou service,
            ou toute information susceptible d’induire l’acheteur en erreur.
          </p>
          <p>
            En cas de photos non contractuelles non signalées, d’informations
            erronées, de produit défectueux non mentionné, de tromperie ou de
            tentative d’escroquerie, l’annonceur s’expose à la suppression de
            son annonce, à la suspension ou suppression de son compte, ainsi
            qu’à d’éventuelles poursuites, réclamations ou actions de la part
            des acheteurs, de Deal.mg ou des autorités compétentes.
          </p>
        </section>

        <section>
          <h4>16. Responsabilité du vendeur</h4>
          <p>
            Le vendeur garantit qu’il dispose du droit de vendre le bien ou le
            service proposé.
          </p>
          <p>
            Il garantit que l’annonce est exacte, claire, sincère et conforme à
            la réalité.
          </p>
          <p>
            Il est interdit au vendeur de publier une annonce pour un produit
            volé, contrefait, dangereux, illégal, inexistant ou qu’il n’est pas
            autorisé à vendre.
          </p>
          <p>
            Le vendeur reste seul responsable de toute réclamation liée au
            produit, au prix, à l’état du bien, à l’origine du bien, à
            l’authenticité du bien, à la conformité du bien, à la disponibilité
            du bien, aux défauts non déclarés, à la livraison ou remise du bien,
            au service après-vente et à toute garantie éventuellement proposée.
          </p>
          <p>
            Le vendeur reconnaît qu’il peut être tenu responsable par l’acheteur
            ou par les autorités compétentes en cas de mensonge, tromperie,
            escroquerie, défaut caché, produit dangereux, produit volé, produit
            contrefait ou information erronée.
          </p>
        </section>

        <section>
          <h4>17. Responsabilité de l’acheteur</h4>
          <p>
            L’acheteur est seul responsable des vérifications qu’il effectue
            avant toute transaction.
          </p>
          <p>
            Il appartient à l’acheteur de s’assurer que le produit correspond à
            ses attentes avant de payer.
          </p>
          <p>
            L’acheteur doit notamment vérifier l’identité du vendeur,
            l’existence réelle du produit, l’état général du produit, la
            conformité du produit à l’annonce, le fonctionnement du produit
            lorsque cela est possible, la présence des accessoires annoncés,
            l’absence de défaut apparent, le prix, les modalités de paiement et
            les conditions de remise ou de livraison.
          </p>
          <p>
            Deal.mg recommande fortement aux acheteurs de ne pas verser
            d’acompte avant d’avoir vu l’article, de ne pas payer avant d’avoir
            vérifié l’article, de tester l’article lorsque cela est possible, de
            demander des photos ou informations complémentaires en cas de doute,
            de se méfier des prix anormalement bas, de refuser toute pression à
            payer rapidement, de ne jamais communiquer leurs codes bancaires ou
            Mobile Money, et de privilégier les remises en main propre dans un
            lieu public et sécurisé.
          </p>
          <p>
            Pour les rencontres entre acheteur et vendeur, Deal.mg recommande
            de choisir un lieu fréquenté et sécurisé, par exemple une grande
            surface, une station-service, un parking surveillé, un lieu public
            fréquenté, un endroit éclairé et accessible.
          </p>
          <p>
            Il est déconseillé de se rendre seul dans un lieu isolé, inconnu ou
            peu fréquenté.
          </p>
          <p>
            L’utilisation de Deal.mg se fait sous la responsabilité et aux
            risques de l’utilisateur.
          </p>
        </section>

        <section>
          <h4>18. Absence de responsabilité de Deal.mg dans les transactions</h4>
          <p>
            Deal.mg ne pourra être tenue responsable, notamment en cas
            d’arnaque, de tentative d’arnaque, de fausse identité, de produit
            contrefait, de produit volé, de défaut produit, de vice caché, de
            produit non conforme, de produit dangereux, de non-livraison, de
            retard de livraison, de non-paiement, d’escroquerie bancaire, de
            litige entre vendeur et acheteur, de perte financière liée à une
            transaction, de comportement frauduleux d’un utilisateur, de vol,
            menace, agression ou incident lors d’une rencontre entre
            utilisateurs.
          </p>
          <p>
            Deal.mg peut mettre en place des outils de signalement, de
            prévention et de modération, mais ne garantit pas l’absence de
            fraude, de contenu illicite ou de comportement malveillant sur la
            plateforme.
          </p>
          <p>
            La modération exercée par Deal.mg ne doit pas être interprétée
            comme une validation, une certification ou une garantie des annonces
            publiées.
          </p>
          <p>Chaque utilisateur doit faire preuve de prudence et de vigilance.</p>
        </section>

        <section>
          <h4>19. Système de signalement</h4>
          <p>
            Deal.mg met à disposition des utilisateurs un système de signalement
            permettant d’alerter la plateforme en cas d’annonce suspecte, de
            tentative d’arnaque, de fausse identité, de produit interdit, de
            produit contrefait, de produit volé, de contenu mensonger, de
            produit défectueux non signalé, de photos non conformes au produit
            réel, de comportement abusif, de propos menaçants, injurieux ou
            discriminatoires, ou de non-respect des présentes conditions.
          </p>
          <p>
            Les signalements peuvent être effectués via les outils disponibles
            sur la plateforme, par téléphone au +261 34 35 36 345, par email à
            contact@deal.mg, ou par tout autre canal officiel communiqué par
            Deal.mg.
          </p>
          <p>
            Deal.mg se réserve le droit d’examiner les signalements et de
            prendre toute mesure utile, notamment demande d’explication,
            modification ou suppression d’une annonce, suspension temporaire
            d’un compte, suppression définitive d’un compte, blocage d’un
            utilisateur, ou transmission d’informations aux autorités
            compétentes si nécessaire.
          </p>
          <p>
            Deal.mg n’est toutefois pas tenue de donner suite à tous les
            signalements ni de communiquer le détail des mesures prises.
          </p>
          <p>
            Le signalement abusif, mensonger ou malveillant peut entraîner la
            suspension ou la suppression du compte de son auteur.
          </p>
        </section>

        <section>
          <h4>20. Contenus interdits</h4>
          <p>
            Il est strictement interdit de publier des annonces concernant
            notamment les drogues, stupéfiants ou substances illicites, les
            armes illégales ou produits dangereux, les produits contrefaits, les
            produits volés, les faux documents, les services frauduleux, les
            escroqueries financières, les systèmes pyramidaux ou promesses de
            gains irréalistes, les contenus à caractère sexuel illégal ou
            exploitatif, les produits ou services portant atteinte à la dignité
            humaine, les produits interdits par la loi malgache, ou tout contenu
            incitant à la haine, à la violence, à la discrimination ou à une
            activité illégale.
          </p>
          <p>
            Deal.mg se réserve le droit d’élargir ou de préciser cette liste à
            tout moment.
          </p>
        </section>

        <section>
          <h4>21. Modération des annonces</h4>
          <p>
            Deal.mg peut contrôler, modifier, refuser, suspendre ou supprimer
            toute annonce qui semble contraire aux présentes conditions, à la
            loi, à l’éthique de la plateforme ou à la sécurité des utilisateurs.
          </p>
          <p>
            Deal.mg peut agir sans préavis en cas de suspicion de fraude,
            d’escroquerie ou tentative d’escroquerie, de contenu interdit,
            d’annonce erronée, mensongère, abusive ou trompeuse, de photos non
            conformes au produit réel, d’informations fausses, incomplètes ou
            de nature à induire l’utilisateur en erreur, de produit défectueux,
            dangereux ou non conforme, de produit dont l’état réel n’est pas
            clairement indiqué, de plainte ou signalement d’un utilisateur, de
            demande d’une autorité compétente, de risque pour la sécurité des
            utilisateurs, ou de risque pour l’image, l’éthique ou le bon
            fonctionnement de la plateforme.
          </p>
          <p>
            La suppression d’une annonce pour non-respect des règles ne donne
            droit à aucun remboursement.
          </p>
          <p>
            Deal.mg se réserve également le droit de refuser la publication
            d’une annonce, même si celle-ci a été soumise ou payée, lorsqu’elle
            ne correspond pas aux standards de sérieux, de transparence, de
            sécurité ou d’éthique attendus sur la plateforme.
          </p>
        </section>

        <section>
          <h4>22. Suspension ou suppression de compte</h4>
          <p>
            Deal.mg peut suspendre ou supprimer un compte utilisateur, sans
            préavis ni indemnité, notamment en cas de fraude, d’arnaque ou
            tentative d’arnaque, d’usurpation d’identité, de publication répétée
            d’annonces interdites, de publication d’annonces erronées,
            abusives, trompeuses ou mensongères, de vente de produits
            défectueux, dangereux ou non conformes sans information claire de
            l’acheteur, de photos non conformes au produit réel, de comportement
            agressif, menaçant ou abusif, de signalements répétés, de
            non-respect des présentes conditions, de comportement contraire à
            l’éthique, aux valeurs ou au sérieux attendu par Deal.mg, de demande
            des autorités compétentes, ou de risque pour la sécurité des autres
            utilisateurs ou de la plateforme.
          </p>
          <p>
            Deal.mg se réserve le droit de supprimer tout compte dont
            l’utilisation ne correspond pas à l’éthique, à l’image, aux
            standards de confiance ou au bon fonctionnement de la plateforme.
          </p>
        </section>

        <section>
          <h4>23. Coopération avec les autorités</h4>
          <p>
            En cas de fraude, suspicion d’infraction, activité illégale ou
            demande officielle, Deal.mg peut conserver et transmettre les
            informations utiles aux autorités compétentes, dans le respect du
            droit applicable.
          </p>
          <p>
            Ces informations peuvent notamment concerner l’identité déclarée de
            l’utilisateur, les coordonnées fournies, les annonces publiées, les
            échanges réalisés via la plateforme, les informations techniques
            disponibles, les historiques de paiement liés aux services Deal.mg,
            et les signalements reçus.
          </p>
        </section>

        <section>
          <h4>24. Données personnelles</h4>
          <p>
            Deal.mg peut collecter et traiter certaines données personnelles
            nécessaires au fonctionnement de la plateforme, notamment nom ou
            pseudonyme, numéro de téléphone, adresse email, informations de
            compte, annonces publiées, messages ou demandes envoyés via la
            plateforme, signalements effectués ou reçus, données techniques de
            connexion, et informations de paiement liées aux services Deal.mg.
          </p>
          <p>
            Ces données sont utilisées notamment pour créer et gérer les comptes
            utilisateurs, publier les annonces, permettre la mise en relation
            entre vendeurs et acheteurs, assurer la sécurité de la plateforme,
            lutter contre la fraude, gérer les paiements, traiter les
            signalements et répondre aux obligations légales.
          </p>
          <p>
            Deal.mg s’engage à traiter les données personnelles conformément au
            droit malgache applicable.
          </p>
          <p>
            L’utilisateur peut demander l’accès, la rectification ou la
            suppression de ses données dans les conditions prévues par la loi,
            en contactant Deal.mg à l’adresse suivante : contact@deal.mg.
          </p>
        </section>

        <section>
          <h4>25. Propriété intellectuelle</h4>
          <p>
            La plateforme Deal.mg, son nom, son logo, son interface, ses textes,
            ses éléments graphiques, ses bases de données et ses fonctionnalités
            sont protégés.
          </p>
          <p>
            Toute reproduction, copie, modification, extraction ou réutilisation
            non autorisée est interdite.
          </p>
          <p>
            L’utilisateur conserve les droits sur les contenus qu’il publie,
            mais autorise Deal.mg à les utiliser, reproduire, afficher, adapter
            et diffuser dans le cadre du fonctionnement de la plateforme, de la
            publication des annonces et de leur promotion.
          </p>
        </section>

        <section>
          <h4>26. Disponibilité de la plateforme</h4>
          <p>
            Deal.mg met en œuvre des moyens raisonnables pour assurer l’accès à
            la plateforme.
          </p>
          <p>
            Toutefois, Deal.mg ne garantit pas un accès permanent, continu ou
            sans erreur.
          </p>
          <p>
            La plateforme peut être temporairement indisponible en cas de
            maintenance, mise à jour, panne technique, cyberattaque, force
            majeure ou événement indépendant de la volonté de Deal.mg.
          </p>
        </section>

        <section>
          <h4>27. Modification des conditions</h4>
          <p>
            Deal.mg se réserve le droit de modifier les présentes CGV / CGU à
            tout moment.
          </p>
          <p>
            Les nouvelles conditions seront applicables dès leur publication sur
            la plateforme.
          </p>
          <p>L’utilisateur est invité à les consulter régulièrement.</p>
        </section>

        <section>
          <h4>28. Force majeure</h4>
          <p>
            Deal.mg ne pourra être tenue responsable en cas d’inexécution ou de
            retard lié à un cas de force majeure ou à un événement indépendant
            de sa volonté, notamment panne réseau, coupure d’électricité,
            cyberattaque, décision administrative, catastrophe naturelle,
            trouble politique, défaillance d’un prestataire technique ou
            indisponibilité d’un service tiers.
          </p>
        </section>

        <section>
          <h4>29. Nullité partielle</h4>
          <p>
            Si une clause des présentes conditions est déclarée nulle ou
            inapplicable, les autres clauses resteront pleinement applicables.
          </p>
          <p>
            La clause concernée sera remplacée, dans la mesure du possible, par
            une clause valable ayant un effet économique et juridique proche.
          </p>
        </section>

        <section>
          <h4>30. Droit applicable</h4>
          <p>Les présentes conditions sont soumises au droit malgache.</p>
        </section>

        <section>
          <h4>31. Tribunal compétent</h4>
          <p>
            En cas de litige relatif à l’utilisation de la plateforme ou aux
            présentes conditions, les parties chercheront d’abord une solution
            amiable.
          </p>
          <p>
            À défaut d’accord amiable, les juridictions compétentes
            d’Antananarivo seront seules compétentes, sauf disposition légale
            impérative contraire.
          </p>
        </section>

        <h3>III. RECOMMANDATIONS DE SÉCURITÉ AUX UTILISATEURS</h3>

        <p>
          Deal.mg recommande aux utilisateurs d’appliquer les règles de prudence
          suivantes :
        </p>

        <ul className="cgv-list">
          <li>Ne versez pas d’acompte avant d’avoir vu l’article.</li>
          <li>Ne payez pas avant d’avoir vérifié et testé l’article lorsque cela est possible.</li>
          <li>Méfiez-vous des prix anormalement bas.</li>
          <li>Ne communiquez jamais vos codes bancaires, codes Mobile Money ou mots de passe.</li>
          <li>Refusez toute pression à payer rapidement.</li>
          <li>Vérifiez l’identité de votre interlocuteur.</li>
          <li>Privilégiez les remises en main propre.</li>
          <li>Choisissez un lieu public, fréquenté et sécurisé pour les rendez-vous.</li>
          <li>Préférez les grandes surfaces, stations-service, parkings surveillés ou lieux bien éclairés.</li>
          <li>Évitez les lieux isolés, inconnus ou peu fréquentés.</li>
          <li>Informez un proche lorsque vous vous rendez à un rendez-vous avec un inconnu.</li>
          <li>Signalez immédiatement toute annonce ou comportement suspect.</li>
        </ul>

        <p>
          Deal.mg rappelle que chaque transaction est conclue directement entre
          vendeur et acheteur, sous leur seule responsabilité.
        </p>

        <p>
          Deal.mg ne garantit ni le sérieux des utilisateurs, ni la réalité des
          produits, ni la bonne exécution des transactions.
        </p>

        <h3>IV. ACCEPTATION</h3>

        <p>
          En utilisant Deal.mg, l’utilisateur reconnaît avoir lu, compris et
          accepté les présentes Conditions Générales de Vente et d’Utilisation.
        </p>
      </article>
    </main>
  );
}